module.exports = __webpack_public_path__ + "static/fonts/iconfont.c99787fa.woff2";